import { useModalVisibility } from '@app/utils/hooks';
import { useTranslation } from 'react-i18next';

import { Button } from '../various/Button';
import { EmptyState } from '../various/EmptyState';

interface Props {
  isError: boolean;
}

export const LookbookEmptyState = ({ isError }: Props) => {
  const { t } = useTranslation(['lookbook']);
  const { showModal } = useModalVisibility('CreateLookbookModal');

  if (isError) {
    return <EmptyState title={t('lookbook:no_lookbooks_found')} />;
  }

  return (
    <EmptyState title={t('lookbook:no_results.default.title')} subtitle={t('lookbook:no_results.default.subtitle')}>
      <Button onClick={showModal}>{t('lookbook:create_lookbook')}</Button>
    </EmptyState>
  );
};
